export default __webpack_public_path__ + "static/media/books-47.56e9be91.jpg";